import { useQuery } from '@tanstack/react-query';
import { Account } from '../../../types/Account';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

export const fetchAccount = async (uuid: string) => {
  const response = await CustomAxios.get<Account>(`accounts/${uuid}`);
  const { data } = response;
  return data;
};

interface UseGetAccountByIdProps {
  uuid: string;
  enabled?: boolean;
}

export function useGetAccountById({ uuid, enabled = true }: UseGetAccountByIdProps) {
  const query = useQuery({
    enabled: enabled,
    queryKey: [queryKeys.allAccounts, uuid],
    queryFn: () => fetchAccount(uuid),
  });

  return query;
}
